import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { format } from "date-fns";

interface IProps {
  name: string;
  startDate: Date;
  endDate: Date;
}

const ExerciseSaleHeader: React.FC<IProps> = ({ name, startDate, endDate }: IProps) => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={6}>
        <Typography variant={"h5"} display={"inline"}>
          {name}
        </Typography>
        <Typography variant={"h5"} display={"inline"}>
          {` / ${format(startDate, "yyyy-MM-dd")}`}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant={"body1"} display={"inline"}>
          {`Godziny otwarcia: ${format(startDate, "HH:mm")} - ${format(endDate, "HH:mm")}`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ExerciseSaleHeader;
